import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
    width: 1200px;
    margin: 0 auto;
    padding: 80px 0 0;
    position: relative;
    margin-top: 20px;
    padding-bottom: 20px;
    ${({ theme }) => theme.mediaWidth.upToSmall`
   width: calc(100vw - 40px);
    margin-top: 10px;
    padding: 80px 0;
    `};
`;

export default function PageWrapper({
    children,
    className,
}: {
    children: React.ReactNode;
    className?: string;
}) {
    return <Wrapper className={className}>{children}</Wrapper>;
}
